import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadProperties } from "../properties/loaders.ts";
import { PropertiesPending } from "../properties/pending.tsx";
import { PropertiesPage } from "../properties/properties-page.tsx";
import { propertiesSearch } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null ? <NoAccessPage /> : <PropertiesPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/properties/")({
  validateSearch: propertiesSearch,
  loader: async ({ context }) => loadProperties(context.data),
  pendingComponent: () => <PropertiesPending kind="gallery" />,
  component: Page,
});
